<template>
  <v-container>
    <v-card>
      <v-card-title class="justify-center"><h1>DOWNLOAD DOCUMENTAZIONE</h1></v-card-title>
      <hr>
      <v-card-text>
        <v-layout justify-center row wrap>
          <v-flex xs12 sm12 md5 >
            <h3 style="text-align: center;">PDF</h3>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <h3 style="text-align: center;">CSV</h3>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 >
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('_LOCDIS.PDF')">PDF - LOCALIT&Agrave; DISAGIATE</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('FLDIS.CSV')">CSV - LOCALIT&Agrave; DISAGIATE</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('_LOCIMP.PDF')">PDF - LOCALIT&Agrave; IMPERVIE</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('FLIMP.CSV')">CSV - LOCALIT&Agrave; IMPERVIE</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('_LOCBAL.PDF')">PDF - LOCALIT&Agrave; BALNEARI</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('FLBAL.CSV')">CSV - LOCALIT&Agrave; BALNEARI</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('_LOCDIFR.PDF')">PDF - LOCALIT&Agrave; DISAGIATE FRANCIA</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('FLDISFR.CSV')">CSV - LOCALIT&Agrave; DISAGIATE FRANCIA</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 >
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('_LOCDIES.PDF')">PDF - LOCALIT&Agrave; DISAGIATE SPAGNA</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('FLDISES.CSV')">CSV - LOCALIT&Agrave; DISAGIATE SPAGNA</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 >
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('_LOCDICH.PDF')">PDF - LOCALIT&Agrave; DISAGIATE SVIZZERA</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5 offset-md1>
            <v-btn large style="box-shadow: none; color: white; margin-left: 0px;" color="#A0A4A7" block @click="Redirect('FLDISCH.CSV')">CSV - LOCALIT&Agrave; DISAGIATE SVIZZERA</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      message: ""
    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.CheckJWT();
  },
   methods: {
     CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err => {
          this.$router.push({ path: `/errore` });
        });
    },
    Redirect(redirect){
      var link = 'http://clienti.arcospedizioni.it/download/' + redirect;
      window.open(link);
      
    }
   }
};
</script>